import type { ReactNode } from "react"
import Link from "next/link"

/**
 * /labels (Konva) и /km нельзя отдавать через next/link на портале:
 * prefetch (в т.ч. по hover) компилирует эти маршруты при открытии главной
 * и забивает CPU/RAM dev-сервера.
 */
export function isCompilerHeavyHref(href: string): boolean {
  return href.startsWith("/labels") || href.startsWith("/km")
}

export function HeavySafeLink({
  href,
  className,
  children,
}: {
  href: string
  className?: string
  children: ReactNode
}) {
  if (href.startsWith("http") || isCompilerHeavyHref(href)) {
    return (
      <a
        href={href}
        className={className}
        {...(href.startsWith("http")
          ? { target: "_blank", rel: "noopener noreferrer" }
          : {})}
      >
        {children}
      </a>
    )
  }

  return (
    <Link href={href} prefetch={false} className={className}>
      {children}
    </Link>
  )
}
